module.exports = __webpack_public_path__ + "img/eef82e6.jpg";